// Central place for tech-stack icons so the gallery card and the detail page
// never fall out of sync. Add an entry here whenever a new project introduces
// a tech that isn't listed yet - the label must match the string used in
// `Project.techStack` exactly.
export const techLogos: Record<string, string> = {
  React: "/tech/React.jpg",
  "Next.js": "/tech/nextjs.png",
  "Node.js": "/tech/Node.png",
  Docker: "/tech/docker.png",
  Kubernetes: "/tech/kubernetes.png",
  MongoDB: "/tech/mongodb.png",
  Express: "/tech/express-js.jpg",
  PostgreSQL: "/tech/postgresql.png",
  Redis: "/tech/redis.jpg",
  FastAPI: "/tech/fastapi.webp",
  Python: "/tech/python.png",
  TensorFlow: "/tech/tensorflow.png",
  Solidity: "/tech/solidity.png",
  Ethereum: "/tech/ethereum.png",
  "Web3.js": "/tech/web3.png",
  AWS: "/tech/aws.png",
};